import React, { useState } from "react";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Form,
    FormGroup,
    Label,
    Input,
    Button,
    Spinner
} from "reactstrap";

import axios from "axios";
import "../Assets/css/style.css";
import AdminSidebar from "../Partials/adminsidebar";

const CreateQuestion = () => {

    const [loading, setLoading] = useState(false);
    const [selectedDomain, setSelectedDomain] = useState("");
    const [formData, setFormData] = useState({
        domain_id: "",
        question: "",
        max_marks: "",
        correct_answer: "",
        keywords: ""
    });

    const handleChange = (e) => {

        const { name, value } = e.target;

        setFormData({
            ...formData,
            [name]: value
        });

        if (name === "domain_id") {
            setSelectedDomain(value);
        }

    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        setLoading(true);

        try {

            const token = localStorage.getItem("admin_token");

            const response = await axios.post(
                // "http://localhost/qads_interview/question/create.php",
                "https://interview.qads.co.in/qads_interview/question/create.php",
                formData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            alert(response.data.message);

            // ✅ Clear form after success
            setFormData({
                domain_id: "",
                question: "",
                max_marks: "",
                correct_answer: "",
                keywords: ""
            });

        } catch (error) {

            if (error.response) {
                alert(error.response.data.message);
            } else {
                alert("Server Error");
            }

        }

        setLoading(false);
    };

    return (
        <div className="create-page">
            <div style={{ display: "flex" }}>

                {/* Sidebar */}
                <AdminSidebar />

                {/* Main Content */}
                <div style={{
                    marginLeft: "250px",
                    width: "100%",
                    padding: "20px"
                }}>


                    <div className="create-page-content">
                        <Container fluid>

                            <Row className="justify-content-center">

                                <Col md="8">

                                    <Card className="question-card">

                                        <CardBody>

                                            <CardTitle className="title">
                                                Create Question
                                            </CardTitle>

                                            <Form onSubmit={handleSubmit}>

                                                <FormGroup>
                                                    <Label>Domain</Label>
                                                    <Input
                                                        type="select"
                                                        name="domain_id"
                                                        value={formData.domain_id}
                                                        onChange={handleChange}
                                                        required
                                                    >
                                                        <option value="">Select Domain</option>
                                                        <option value="1">Content Creation</option>
                                                        <option value="2">Sales</option>
                                                        <option value="3">Accountant</option>
                                                    </Input>
                                                </FormGroup>

                                                <FormGroup>
                                                    <Label>Question</Label>
                                                    <Input
                                                        type="textarea"
                                                        name="question"
                                                        value={formData.question}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                </FormGroup>

                                                {/* Only for Content Creation */}

                                                {selectedDomain === "1" && (
                                                    <>
                                                        <FormGroup>
                                                            <Label>Max Marks</Label>
                                                            <Input
                                                                type="number"
                                                                name="max_marks"
                                                                value={formData.max_marks}
                                                                onChange={handleChange}
                                                                min="0"
                                                            />
                                                        </FormGroup>

                                                        <FormGroup>
                                                            <Label>Correct Answer</Label>
                                                            <Input
                                                                type="text"
                                                                name="correct_answer"
                                                                value={formData.correct_answer}
                                                                onChange={handleChange}
                                                            />
                                                        </FormGroup>

                                                        <FormGroup>
                                                            <Label>Keywords</Label>
                                                            <Input
                                                                type="text"
                                                                name="keywords"
                                                                value={formData.keywords}
                                                                onChange={handleChange}
                                                            />
                                                        </FormGroup>
                                                    </>
                                                )}

                                                <Button
                                                    className="submit-btn"
                                                    disabled={loading}
                                                    block
                                                >
                                                    {loading ? <Spinner size="sm" /> : "Create Question"}
                                                </Button>

                                            </Form>

                                        </CardBody>

                                    </Card>

                                </Col>

                            </Row>

                        </Container>

                    </div>

                </div>
            </div>

        </div>
    );
};

export default CreateQuestion;